import { useTheme } from "@mui/material";
import { ToastContainer as ReactToastifyContainer, ToastOptions } from "react-toastify";

export const ToastContainer = () => {
  const theme = useTheme();

  const defaultOptions: ToastOptions = {
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: true,
    pauseOnHover: true,
  };

  return (
    <ReactToastifyContainer
      {...defaultOptions}
      toastStyle={{
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
      }}
      theme={theme.palette.mode}
    />
  );
};
